<form [formGroup]="podForm" (ngSubmit)="isFormSubmitted = true;onSaveClick()">
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Update Status</h4>
        <button type="button" class="btn-close" aria-label="Close"
            (click)="activeModal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-md-12">
                <div class="card1">
                    <!-- <div class="card-header bg-transparent border-bottom text-uppercase">Update Status</div> -->
                    <div class="card-body1">
                        <div class="row">
                            <div class="col-12">
                                <div class="alert alert-secondary alert-dismissible fade show mb-0 justify-content-center"
                                    role="alert">
                                    <!-- <i class="mdi mdi-alert-circle-outline me-2"></i> -->
                                    Current Status: <span class="badge bg-dark statusbadge" *ngIf="currentStatus">
                                        {{currentStatus}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col-md-12">
                                <label class="form-label custom-info-label">
                                    <i class="mdi mdi-alert-circle-outline me-1"></i>
                                    Note: Updating master AWB also updates status for all of their childs as well.
                                </label>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col-md-12">
                                <div class="mb-2">
                                    <label for="awbnumber" class="form-label">Awb Number<span
                                            class="mandatory">*</span></label>
                                    <ng-select [items]="awbList" bindLabel="awbnumber" [bindValue]="'awbnumber'"
                                        formControlName="txtAwbNo" (change)="onAwbChange()"
                                        class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"
                                        [ngClass]="{'is-invalid': (isFormSubmitted || podForm.get('txtAwbNo')?.touched) && podForm.get('txtAwbNo').errors}">
                                        <ng-template ng-option-tmp let-item="item">
                                            <div class="item-container">
                                                {{ item.awbnumber }}
                                                <span [innerHTML]="status(item.status)"></span>
                                            </div>
                                        </ng-template>
                                    </ng-select>
                                    <div *ngIf="(isFormSubmitted || podForm.get('txtAwbNo')?.touched) && podForm.get('txtAwbNo').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="podForm.get('txtAwbNo').errors.required">Awb Number is
                                            required.</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">

                            <div class=" col-md-6">
                                <div class="mb-2">
                                    <label for="podStatus" class="form-label">Status<span
                                            class="mandatory">*</span></label>
                                    <ng-select id="podStatus" placeholder="Select" [items]="statusList"
                                        formControlName="ddlStatus" bindLabel="name" [bindValue]="'id'"
                                        (change)="onStatusChange()"
                                        class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"
                                        [ngClass]="{'is-invalid': (isFormSubmitted || podForm.get('ddlStatus')?.touched) && podForm.get('ddlStatus').errors}">
                                    </ng-select>
                                    <div *ngIf="(isFormSubmitted || podForm.get('ddlStatus')?.touched) && podForm.get('ddlStatus').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="podForm.get('ddlStatus').errors.required">Status is
                                            required.</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="isDelivered" class="row">
                            <div class="col-md-4">
                                <div class="mb-2">
                                    <label for="excepteddelvdate" class="form-label">Delivered Date<span
                                            class="mandatory">*</span></label>
                                    <input type="datetime-local" id="excepteddelvdate" [min]="estimatedDeliveryDate"
                                        class="form-control form-control-sm" formControlName="txtExpectedDelvDate"
                                        [ngClass]="{'is-invalid': (isFormSubmitted || podForm.get('txtExpectedDelvDate')?.touched) && podForm.get('txtExpectedDelvDate').errors}">
                                    <div *ngIf="(isFormSubmitted || podForm.get('txtExpectedDelvDate')?.touched) && podForm.get('txtExpectedDelvDate').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="podForm.get('txtExpectedDelvDate').errors.required">Date is
                                            required.</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-4">
                                <div class="mb-2">
                                    <label for="receivename" class="form-label">Receiver Name</label>
                                    <input type="text" id="receivename" class="form-control form-control-sm"
                                        formControlName="txtReceiverName" />
                                </div>
                            </div>

                            <div class="col-md-4">
                                <div class="mb-2">
                                    <label for="mobileNo" class="form-label">Mobile No.</label>
                                    <input type="number" id="mobileNo" class="form-control form-control-sm"
                                        formControlName="txtMobileNo" appLimitDigits [length] = "10"
                                        [ngClass]="{'is-invalid': (isFormSubmitted || podForm.get('txtMobileNo')?.touched) && podForm.get('txtMobileNo').errors}">
                                    <div *ngIf="(isFormSubmitted || podForm.get('txtMobileNo')?.touched) && podForm.get('txtMobileNo').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="podForm.get('txtMobileNo').errors.pattern">Must be of 10
                                            digits.</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="isDelayed" class="row">
                            <div class="col-md-4">
                                <div class="mb-2">
                                    <label for="txtDays" class="form-label">Days</label>
                                    <input type="number" id="txtDays" class="form-control form-control-sm"
                                        placeholder="00" formControlName="txtDays"
                                        [ngClass]="{'is-invalid': (isFormSubmitted || podForm.get('txtDays').touched) && podForm.get('txtDays').errors}">
                                    <div *ngIf="(isFormSubmitted || podForm.get('txtDays').touched) && podForm.get('txtDays').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="podForm.get('txtDays').errors.max">Max upto 30 days</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="mb-2">
                                    <label for="txtHours" class="form-label">Hours</label>
                                    <input type="number" id="txtHours" class="form-control form-control-sm"
                                        placeholder="00" formControlName="txtHours"
                                        [ngClass]="{'is-invalid': (isFormSubmitted || podForm.get('txtHours').touched) && podForm.get('txtHours').errors}">
                                    <div *ngIf="(isFormSubmitted || podForm.get('txtHours').touched) && podForm.get('txtHours').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="podForm.get('txtHours').errors.max">Max upto 23 hours or add a
                                            day</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="mb-2">
                                    <label for="remark" class="form-label">Remark <span *ngIf="!isDelivered && !isInTransit" class="mandatory">*</span> </label>
                                            <div class="input-group">
                                                <input formControlName="txtRemark" type="text" class="form-control col form-control-sm"
                                                    placeholder="Type to search" 
                                                    [ngClass]="{'is-invalid': (isFormSubmitted || podForm.get('txtRemark').touched) && podForm.get('txtRemark').errors}"
                                                    [ngbTypeahead]="searchRemark" [resultTemplate]="rt"
                                                    [inputFormatter]="searchFormatter"
                                                    />
                                            </div>
                                            <ng-template #rt let-r="result" let-t="term">
                                                <ngb-highlight [result]="r.remark" [term]="t"></ngb-highlight>
                                            </ng-template>
                                    
                                        <div *ngIf="(isFormSubmitted || podForm.get('txtRemark').touched) && podForm.get('txtRemark').errors" class="invalid-feedback">
                                            <span *ngIf="podForm.get('txtRemark').errors.required">Remark is Required</span>
                                        </div>
                                </div>
                            </div>

                            <div *ngIf="isDelivered" class="row">
                                <div class="col-md-12">
                                    <div class="mb-2">
                                        <label for="Document" class="form-label">Upload POD</label>
                                        <div class="input-group">
                                            <input id="Document" type="file" class="form-control form-control-sm"
                                                (change)="onChangeFileSelect($event)" accept=".png, .jpeg, .jpg, .svg">
                                            <button type="button" class="btn btn-primary btn-sm" (click)="uploadFile()">
                                                <i class="bx bx-upload font-size-16 align-middle me-2"></i>
                                                Upload
                                            </button>
                                        </div>
                                        <small for="Document">
                                            <i class="mdi mdi-information">Note: .png, .jpeg, .jpg, .svg are only
                                                allowed</i>
                                        </small>
                                    </div>
                                </div>
                            </div>

                            <div class="row" *ngIf="isShipmentHold" formGroupName="shipmentHoldDetails">
                                <div class="col-md-8">
                                    <div class="mb-2">
                                        <label for="" class="form-label">Email</label>
                                        <input type="text" placeholder="Enter a Email"
                                            class="form-control form-control-sm" formControlName="txtEmail"
                                            [ngClass]="{'is-invalid':(isFormSubmitted || podForm.get('shipmentHoldDetails.txtEmail').touched) && podForm.get('shipmentHoldDetails.txtEmail').errors}">
                                        <div *ngIf=" (isFormSubmitted || podForm.get('shipmentHoldDetails.txtEmail').touched) && podForm.get('shipmentHoldDetails.txtEmail').errors"
                                            class="invalid-feedback">
                                            <span
                                                *ngIf="podForm.get('shipmentHoldDetails.txtEmail').errors.pattern">Invalid
                                                Email.</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <!-- <button type="button" class="btn btn-outline-dark" (click)="resetFrom();"  [disabled]="currentStatus=='DELIVERED'">Reset</button> -->
        <button type="submit" class="btn btn-primary" [disabled]="currentStatus=='DELIVERED'">Save</button>
    </div>
</form>